"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkBodyTypebox = checkBodyTypebox;
exports.checkResponseTypebox = checkResponseTypebox;
exports.makeBaseRouteInput = makeBaseRouteInput;
exports.replyStatus = replyStatus;
exports.replyRedirect = replyRedirect;
exports.replySetCorsHeaderOnDev = replySetCorsHeaderOnDev;
exports.replySetCorsHeader = replySetCorsHeader;
const lodash_1 = __importDefault(require("lodash"));
const TypeCheck_1 = require("./TypeCheck");
const UrlQs_1 = require("./UrlQs");
const Errors_1 = require("./Errors");
/**
 * Runs checkTypebox on the body provided by the route input against the
 * route's defined/expected bodyT.
 * Throws E_INVALID_PARAMETERS on failure.
 *
 * @param TSchema bodyT
 * @param BaseRouteInput routeInput
 */
function checkBodyTypebox(bodyT, routeInput) {
    const { body, url, log } = routeInput;
    try {
        (0, TypeCheck_1.checkTypebox)({
            schema: bodyT,
            value: body,
            errorPrefix: url + " body",
            log,
        });
    }
    catch (ex) {
        throw new Errors_1.RequestError("E_INVALID_PARAMETERS", ex.message);
    }
}
/**
 * Given a handler's response, run checkTypebox on the response object against
 * the route's defined/expected responseT.
 * Logs at the error level on fail and optionally throws ServerError.
 *
 * @param any response
 * @param Tschema responseT
 * @param BaseRouteInput routeInput
 *
 * Optional parameters:
 * - throwOnFail: If passed, throws a server level error on fail.
 */
function checkResponseTypebox(opts) {
    const { response, responseT, routeInput, throwOnFail } = opts;
    const { url, log, method } = routeInput;
    try {
        (0, TypeCheck_1.checkTypebox)({
            schema: responseT,
            value: response,
            errorPrefix: url + " response",
            log,
        });
    }
    catch (ex) {
        log.error({
            module: "RouteWrap",
            fn: "checkResponseTypebox",
            label: "FailedResponseTypeCheck",
            method,
            url,
            originalError: (0, Errors_1.makeLoggableError)(ex),
        });
        if (throwOnFail) {
            throw new Errors_1.ServerError("E_INVALID_RESPONSE", {
                moreInfo: {
                    originalResponse: response,
                    responseT,
                    errorMessage: ex.message,
                },
            });
        }
    }
}
/**
 * Includes all of the necessary fields that can be derived from a request
 * necessary for a Fastify project that can be extended depending on project
 * needs.
 *
 * @param request The Fastify request object.
 * @returns A complete BaseRouteInput object.
 */
function makeBaseRouteInput(request) {
    let body = request.body;
    if ((0, UrlQs_1.isMethodDisallowingBody)(request.method)) {
        body = request.query;
    }
    return {
        requestId: request.id,
        method: request.method,
        url: request.url,
        params: request.params,
        query: request.query,
        body,
        log: request.log,
    };
}
/**
 * Reply with a given status code and reply body.
 *
 * @param status The HTTP status code to reply with.
 * @param body   The response body sent as JSON.
 */
function replyStatus(_request, reply, status, body) {
    reply.code(status);
    if (lodash_1.default.isObject(body)) {
        reply.header("Content-Type", "application/json; charset=utf-8");
    }
    reply.send(body);
}
/**
 * Reply with a redirect to a given URL.
 */
function replyRedirect(_request, reply, url) {
    reply.redirect(302, url);
}
/**
 * Set the reply to return CORS header if the server is in a dev environment.
 */
function replySetCorsHeaderOnDev(reply, isDev) {
    if (!isDev) {
        return;
    }
    replySetCorsHeader(reply);
}
/**
 * Set the reply to return a CORS header.
 */
function replySetCorsHeader(reply) {
    reply.header("Access-Control-Allow-Origin", "*");
}
//# sourceMappingURL=RouteWrap.js.map